import DOMPurify from "dompurify";
import { ElementType, FC } from "react";

interface IRentableGroupCalculatorHtmlContentProps {
  html: string;
  as?: ElementType;
  className?: string;
  id?: string;
}

const RentableGroupCalculatorHtmlContent: FC<
  IRentableGroupCalculatorHtmlContentProps
> = ({ html, as: Tag = "div", className = "", id }) => {
  if (!html) return null;

  return (
    <Tag
      id={id}
      className={`${className} reset-global-styles cke_editable`.trim()}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(html),
      }}
    />
  );
};

export default RentableGroupCalculatorHtmlContent;
